<template>
	<v-container fluid class="relative">
		<div class="white" id="tool-bar">
			<v-row align="center" justify="start" class="mb-3">
				<v-col lg="2" md="6" sm="6" cols="12" class="d-flex justify-start">
					<slot name="breadcrumbs"></slot>
				</v-col>
				<v-spacer/>
				<v-col lg="2" md="6" sm="6" cols="12" class="d-flex flex-sm-nowrap flex-wrap justify-end align-center">
					<!-- color="addingColor white--text" -->
					<v-btn
						class="rounded-small mb-sm-0 mb-1"
						color="success white--text"
						:width="$vuetify.breakpoint.xsOnly ? '100%' : null"
						@click="financialFileDialog = true"
					>
						<v-icon class="me-1">mdi-plus-circle-outline</v-icon>
						{{$t('FinancialFilesPage.create-financial-file')}}
					</v-btn>
					
					<!-- backup -->
					<!-- color="deletingColor white--text" -->
					<v-btn
						v-if="isAdmin"
						color="alert-color white--text"
						class="rounded-small ms-sm-3"
						:width="$vuetify.breakpoint.xsOnly ? '100%' : null"
						:loading="backupLoading"
						:disabled="backupLoading"
						@click="createBackup"
					>
						<v-icon class="me-1">mdi-database-arrow-down</v-icon>
						{{$t('FinancialFilesPage.create-backup')}}
					</v-btn>
				</v-col>
			</v-row>
		</div>

		<!-- change financial file dialog -->
		<bee-dialog
			v-model="changeFinancialFileDialog"
			max-width="400"
			:title="$t('FinancialFilesPage.browse-content') + ' ' + financialFile.companyName"
			:confirm-btn-content="$t('FinancialFilesPage.confirm')"
			@click:confirm="changeFinancialFile()"
			@click:close="changeFinancialFileDialog = false"
		>
			{{
				$t('FinancialFilesPage.do-you-want-to-change-the-current-financial-file')
				+ ` (${currentFinancialFile.name})!`
			}}
		</bee-dialog>

		<!-- financial file data -->
		<bee-dialog
			v-model="financialFileDialog"
			:title="
				!financialFile.id
				? $t('FinancialFilesPage.create-financial-file')
				: $t('FinancialFilesPage.edit-financial-file')
			"
			:confirm-btn-content="$t('buttons.save')"
			:disable-confirm="!isValidFinancialFileData || permissionsLoading || financialFileLoading"
			:loading-confirm="financialFileLoading"
			:loading="financialFileLoading"
			:persistent="permissionsLoading"
			max-width="600"
			@click:confirm="save"
			@click:close="financialFileDialog = false"
		>
			<v-form
				v-model="isValidFinancialFileData"
				ref="financialFileForm"
				:disabled="financialFileLoading"
			>
				<v-row class="ma-0" justify="center">
					<v-col sm="7" cols="12" class="d-flex pt-0 pb-2">
						<v-img
							:src="
								financialFile.fileLogo
									? getLogo(financialFile.fileLogo)
									: require('@/assets/placeholder-image.png')
								"
							lazy-src="@/assets/placeholder-image.png"
							contain
							width="38"
							height="38"
						/>

						<!-- upload logo -->
						<!-- @change="onUpload()" -->
						<div class="mx-2">
							<v-file-input
								v-model="financialFile.image"
								accept="image/png"
								:prepend-icon="financialFile.image ? 'mdi-image' : 'mdi-paperclip'"
								outlined
								dense
								hide-input
							></v-file-input>
						</div>

						<!-- company -->
						<v-text-field
							v-model="financialFile.companyName"
							dense
							outlined
							:label="$t('inputs.company-name')"
							:rules="[rules.required]"
						></v-text-field>
					</v-col>
					
					<!-- year name -->
					<v-col sm="5" cols="12" class="pt-0 pb-2">
						<v-text-field
							v-model="financialFile.yearName"
							dense
							outlined
							:label="$t('inputs.fiscal-year')"
							:rules="[rules.required]"
						></v-text-field>
					</v-col>
					
					<!-- start date -->
					<v-col sm="6" cols="12" class="px-0 pt-0 pb-2">
						<bee-date-picker
							v-model="financialFile.startDate"
							:label="$t('inputs.financial-file-start')"
							:rules="[rules.date]"
							:action-name="actions.CREATE"
							context="financial_file"
						></bee-date-picker>
					</v-col>
					
					<!-- end date -->
					<v-col sm="6" cols="12" class="px-0 pt-0 pb-2">
						<bee-date-picker
							v-model="financialFile.endDate"
							:label="$t('inputs.financial-file-end')"
							:rules="[rules.date]"
							context="financial_file"
							:action-name="actions.CREATE"
						></bee-date-picker>
					</v-col>
					
					<!-- default currency id -->
					<!-- :items="configs.currencies" -->
					<v-col sm="6" cols="12" class="pt-0 pb-2">
						<v-autocomplete
							:label="$t('inputs.currency')"
							v-model="financialFile.defaultCurrencyId"
							:disabled="Boolean(financialFile.id)"
							:items="currencies"
							:rules="[rules.required]"
							:item-text="item => `${item.name} - ${item.symbol}`"
							item-value="id"
							dense
							outlined
						></v-autocomplete>
					</v-col>
					
					<!-- default language -->
					<v-col sm="6" cols="12" class="pt-0 pb-2">
						<v-autocomplete
							v-model="financialFile.defaultLanguage"
							:label="$t('inputs.default-language')"
							:items="availableLangs"
							item-value="id"
							item-text="name"
							dense
							outlined
							:rules="[rules.language]"
						></v-autocomplete>
					</v-col>
				</v-row>

				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				
				<!-- <div class="d-flex flex-wrap align-center">
					<span class="text-body-1 font-weight-bold">
						{{$t('FinancialFilesPage.permissions.title')}}
					</span>
					<v-btn
						depressed
						color="success white--text"
						class="ms-2"
						text
						width="35"
						min-width="35"
						height="35"
						:loading="permissionsLoading"
						@click="addUserPermission()"
					>
						<v-icon>mdi-plus-circle-outline</v-icon>
					</v-btn>
				</div> -->

				<!-- <v-row
					v-for="(userPermission, i) in userPermissions"
					:key="i"
					class="justify-sm-space-between ma-0 mt-2"
				> -->
					<!-- user -->
					<!-- <v-col sm="5" cols="12" class="px-sm-0 py-0">
						<v-autocomplete
							v-model="userPermission.userId"
							:label="$t('inputs.name')"
							:items="unselectedUsers"
							item-value="id"
							item-text="user_name"
							outlined
							dense
							:loading="permissionsLoading"
							:rules="[rules.required]"
							ref="username"
						></v-autocomplete>
					</v-col> -->
					
					<!-- permission type -->
					<!-- <v-col sm="5" cols="10" class="px-sm-0 py-0">
						<v-autocomplete
							v-model="userPermission.permissionType"
							:label="$t('inputs.permission')"
							:items="permissions"
							item-value="permissionType"
							item-text="value"
							outlined
							dense
							:loading="permissionsLoading"
							:rules="[rules.required]"
						></v-autocomplete>
					</v-col> -->

					<!-- this one was a comment before -->
					<!-- <v-col 
						v-if="multipleWarehouses && (userPermission.permissionType === userType.warehouseKeeper)"
						sm="10" cols="10" class="px-sm-0 py-0"
					>
						<v-autocomplete 
							v-model="userPermission.warehouseIds"
							:items="warehouses"
							item-text="name"
							item-value="id"
							dense
							outlined
							hide-details
							:label="$t('inputs.warehouse')"
						/>
					</v-col> -->

					<!-- remove button -->
					<!-- <v-col sm="auto" cols="2" class="text-center px-sm-0 py-0">
						<v-btn
							color="danger-color white--text"
							depressed
							width="35"
							min-width="35"
							height="35"
							class="mt-1"
							:disabled="permissionsLoading"
							@click="userPermissions.splice(i, 1)"
						>
							<v-icon>mdi-delete</v-icon>
						</v-btn>
					</v-col> -->
				<!-- </v-row> -->

				<!-- <p v-if="!userPermissions.length" class="my-1">
					{{$t('FinancialFilesPage.permissions.no-permissions')}}
				</p> -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
				<!-- Work Space -->
			</v-form>
		</bee-dialog>
		
		<!-- filter -->
		<v-form @submit.prevent="isFiltered = true; filter();" class="border-container">
			<v-row class="align-center ma-0">
				<!-- name -->
				<v-col md="3" sm="4" cols="12" class="py-sm-0 ps-sm-0">
					<v-text-field
						v-model="filterData.name"
						:label="$t('inputs.name')"
						:disabled="filterLoading"
						dense
						hide-details
						outlined
					></v-text-field>
				</v-col>
				
				<!-- fiscal year -->
				<v-col md="2" sm="3" cols="12" class="py-sm-0 ps-sm-0">
					<v-text-field
						v-model="filterData.fiscalYear"
						:label="$t('inputs.fiscal-year')"
						:disabled="filterLoading"
						dense
						hide-details
						outlined
					></v-text-field>
				</v-col>
				
				<!-- search -->
				<v-col cols="auto" class="py-sm-0 ps-sm-0">
					<v-btn
						type="submit"
						color="info-light-color white--text"
						:disabled="filterLoading"
					>
						<v-icon size="20" class="me-1">mdi-magnify</v-icon>
						{{$t('buttons.search')}}
					</v-btn>

					<v-btn
						v-if="isFiltered"
						icon
						class="ms-2"
						@click="resetFilter"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-col>
			
				<v-spacer/>
			
				<!-- show archived -->
				<v-col cols="auto" class="py-sm-0 ps-sm-0">
					<v-checkbox
						v-model="showArchived"
						:label="$t('inputs.show-archived')"
						hide-details
						class="mt-0"
					/>
				</v-col>
			</v-row>
		</v-form>
		
		<!-- tabs -->
		<v-tabs
			v-model="tab"
			grow
			height="40"
			class="rounded-lg overflow-hidden my-3"
			active-class="primary lighten-1 white--text"
			center-active
			show-arrows
		>
			<v-tab class="blue-grey lighten-5">
				<v-icon size="24" class="me-2">mdi-lock-open-variant-outline</v-icon>
				{{$t('FinancialFilesPage.unlocked')}}
			</v-tab>
			<v-tab class="blue-grey lighten-5">
				<v-icon size="24" class="me-2">mdi-lock-outline</v-icon>
				{{$t('FinancialFilesPage.locked')}}
			</v-tab>
			<v-tab class="blue-grey lighten-5">
				<v-icon size="24" class="me-2">mdi-rotate-3d-variant</v-icon>
				{{$t('FinancialFilesPage.rotated')}}
			</v-tab>
		</v-tabs>
		
		<!-- table -->
		<bee-handy-table
			:headers="headers"
			:items="!loading ? filteredFinancialFiles : []"
			dense
			pagination-on-scroll
			fixed-header
			:height="$vuetify.breakpoint.height - 300"
			:shown-rows-text="$t('components.shown-rows')"
			:loading="loading || filterLoading"
		>
			<!-- company-logo -->
			<template v-slot:item.company-logo="{ item }">
				<v-img
					:src="
						item.company_logo_file
							? getLogo(item.company_logo_file)
							: require('@/assets/placeholder-image.png')
						"
					lazy-src="@/assets/placeholder-image.png"
					width="38"
					height="38"
				/>
			</template>

			<!-- is locked -->
			<template v-slot:item.isLocked="{ item }">
				<div
					:class="
						item.rotation_date
						? 'deletingColor--text'
						: item.is_locked ? 'unactive--text' : 'success--text'
					"
					class="d-flex align-center"
				>
					<v-icon
						left
						dark
						class="mx-1"
						:color="
							item.rotation_date
								? 'deletingColor'
								: (item.is_locked ? 'unactive' : 'success')
						"
					>
						{{
							item.rotation_date
								? 'mdi-sync'
								: (item.is_locked ? 'mdi-lock-outline' : 'mdi-lock-open-variant-outline' )
						}}
					</v-icon>
					<span class="mx-1">
						{{
							item.rotation_date
								? $t('FinancialFilesPage.rotated-to-$',
									{
										financialFile: getFinancialFileById(item.rotated_financial_file_id).company_name
									}
								)
								: item.is_locked
									? $t('FinancialFilesPage.locked')
									: $t('FinancialFilesPage.unlocked')
						}}
					</span>
				</div>
			</template>

			<template v-slot:item.actions="{ item }">
				<!-- preview file -->
				<tooltip :text="$t('tooltip.preview-file')" content-class="me-2">
					<v-btn
						depressed
						height="34"
						width="38"
						min-width="38"
						color="preview-color white--text"
						class="px-1"
						:disabled="currentFinancialFile.id === item.id"
						@click="
							currentFinancialFile.id !== item.id
								? (() => {
									financialFile.id = item.id;
									financialFile.companyName = item.company_name;
									changeFinancialFileDialog = true;
								})()
								: null
						"
					>
						<v-icon>mdi-folder-open</v-icon>
					</v-btn>
				</tooltip>
				
				<!-- edit -->
				<tooltip :text="$t('buttons.edit')" content-class="me-2">
					<v-btn
						depressed
						height="34"
						width="38"
						min-width="38"
						color="edit-color white--text"
						class="px-1"
						@click="financialFileDialog = true; financialFile.id = item.id"
					>
						<v-icon>mdi-pencil</v-icon>
					</v-btn>
				</tooltip>

				<!-- archive -->
				<tooltip
					:text="!item.is_archived ? $t('tooltip.archive') : $t('tooltip.unarchive')"
					content-class="me-2"
				>
					<v-btn
						icon
						:color="!item.is_archived ? 'grey darken-1' : 'info-color'"
						class="px-1 white--text"
						:loading="changeArchiveFileId === item.id"
						:disabled="Boolean(changeArchiveFileId)"
						@click="changeArchiveState(item.id, !item.is_archived)"
					>
						<v-icon>
							{{
								!item.is_archived
									? 'mdi-archive-outline'
									: 'mdi-archive'
							}}
						</v-icon>
					</v-btn>
				</tooltip>
			</template>
		</bee-handy-table>
	</v-container>
</template>
<script>
import rules from "../../../validation";
import { mapState, mapGetters } from "vuex";
import actions from "../../../permissions/actions-names.js"
import ls from '../../../settings/localStorageExtension'
import availableLangs from '../../../settings/constants/availableLangs'
import EventBus from '../../../event-bus'
import { userType } from '../../../helpers/enums'
import { multipleWarehouses } from '../../../configs/global'
export default {
	data: () => ({
		// helpers
		tab: 0,
		showArchived: null,
		
		loading: false,
		financialFileLoading: false,
		permissionsLoading: false,
		backupLoading: false,

		changeFinancialFileDialog: false,

		changeArchiveFileId: null,

		isValidFinancialFileData: false,
		financialFileDialog: false,
		
		isValidPermissions: false,
		permissionsDialog: false,
		
		availableLangs,
		actions,
		...rules,

		// filter
		isFiltered: false,
		filterLoading: false,
		filterData: {
			name: null,
			fiscalYear: null,
		},

		// Data
		userPermissions: [],
		financialFile: {
			id: null,
			companyName: null,
			yearName: null,
			startDate: null,
			endDate: null,
			defaultCurrencyId: null,
			defaultLanguage: 0,
			image: null,
		},
		userType,
		multipleWarehouses
	}),

	watch: {
		financialFileDialog(val) {
			if (val) {
				const file = this.getFinancialFileById(this.financialFile.id);
				if (file) {
					this.financialFile.companyName = file.company_name;
					this.financialFile.yearName = file.year_name;
					this.financialFile.startDate = file.start_date;
					this.financialFile.endDate = file.end_date;
					this.financialFile.defaultCurrencyId = file.default_currency_id;
					this.financialFile.defaultLanguage = file.default_language;
					this.financialFile.fileLogo = file.company_logo_file;
					this.financialFileDialog = true;
					
					// fetch permissions
					/* this.permissionsLoading = true;
					this.$store.dispatch('financialFiles/fetchPermissions', this.financialFile.id)
						.then(data => {
							if(data.length > 0) {
								const permissionsArr = [];
								data.forEach(item => {
									permissionsArr.push({
										userId: item.user_id,
										permissionType: item.permission_type,
										warehouseIds: item.warehouse_ids ? item.warehouse_ids[0] : null
									})
								});
								this.userPermissions = permissionsArr;
							}
						})
						.finally(() => {
							this.permissionsLoading = false;
						}) */
				} else {
					const currentYear = String(new Date().getFullYear() + 1);
					this.financialFile.startDate = `${currentYear}-01-01`;
					this.financialFile.endDate = `${currentYear}-12-31`;
				}
			}
			else {
				this.$refs.financialFileForm.reset();
				this.financialFile.id = null;
				this.financialFile.startDate = null;
				this.financialFile.endDate = null;

				this.userPermissions = [];
			}
		}
	},

	computed: {
		...mapState({
			configs: state => state.configs.configs,
			currencies: state => state.currencies.currencies,
			financialFiles: state => state.financialFiles.financial_files,
			users: state => state.users.users,
			// warehouses: state => state.warehouses.warehouses,
			// userTypePermission: state => state.permissions.user_type
		}),

		...mapGetters({
			isAdmin: 'auth/isAdmin',
			getFinancialFileById: 'financialFiles/getFinancialFileById',
		}),

		// this part of code will be deleted later because it will be moved to the users page
		// permissions(){
		// 	return [
		// 		{
		// 			permissionType: 2,
		// 			value: this.$t('FinancialFilesPage.permissions.viewer'),
		// 			name: 'Viewer'
		// 		},
		// 		{
		// 			permissionType: 1,
		// 			value: this.$t('FinancialFilesPage.permissions.accountant'),
		// 			name: 'Accountant'
		// 		},
		// 		{
		// 			permissionType: 3,
		// 			value: this.$t('FinancialFilesPage.permissions.warehouse-keeper'),
		// 			name: 'WarehouseKeeper'
		// 		},
		// 		{
		// 			permissionType: 4,
		// 			value: this.$t('FinancialFilesPage.permissions.warehouse-manager'),
		// 			name: 'WarehouseManger'
		// 		}
		// 	]
		// },

		headers() {
			const headers = [
				{
					text: '#',
					name: 'no',
					value: 'id',
					setValueExpr: (value, index) => index + 1,
					sortable: false,
					width: 50
				},
				{
					text: '',
					name: 'company-logo',
					value: 'company_logo_file',
					align: 'center',
					sortable: false,
					width: 50
				},
				{
					text: this.$t('headers.company-name'),
					name: 'company-name',
					value: 'company_name',
					width: 100
				},
				{
					text: this.$t('headers.fiscal-year'),
					name: 'year-name',
					value: 'year_name',
					type: 'string',
					width: '10%'
				},
				{
					text: this.$t('headers.start-date-of-the-file'),
					name: 'start-date',
					value: 'start_date',
					width: 120
				},
				{
					text: this.$t('headers.end-date-of-the-file'),
					name: 'end-date',
					value: 'end_date',
					width: 120
				},
				{
					text: this.$t('headers.currency'),
					name: 'currency',
					value: 'default_currency_id',
					type: 'currencies-autocomplete',
					setValueExpr: (value) => this.getCurrencyById(value)?.symbol,
					width: 40,
				},
				{
					text: this.$t('headers.state'),
					name: 'isLocked',
					value: 'is_locked',
					width: 120,
					sortable: false,
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					sortable: false,
					width: 220,
				}
			];

			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-2' : 'px-2'
			}

			return headers;
		},

		filteredFinancialFiles() {
			const items = this.financialFiles.filter(c => this.showArchived ? true : !c.is_archived );
			if (this.tab === 1) {
				return items.filter(c => c.is_locked);
			} else if (this.tab === 2) {
				return items.filter(c => c.rotated_financial_file_id);
			}
			return items.filter(c => !c.is_locked && !c.rotated_financial_file_id);
		},

		currentFinancialFile(){
			return {
				id: ls.getLocalFinancialFileId(),
				name: this.configs?.financial_file?.company_name
			}
		},
		
		// this part of code has been moved to the users page so it will be deleted later
		// unselectedUsers(){
		// 	return this.users.filter(c => !c.is_admin).map(item => ({
		// 		...item,
		// 		disabled: this.userPermissions.map(c => c.userId).includes(item.id)
		// 	}))
		// },
		//
	},

	methods: {
		filter() {
			this.filterLoading = true;
			return this.$store.dispatch('financialFiles/fetchAll', {
				fiscalYear: this.filterData.fiscalYear,
				companyName: this.filterData.name,
			}).then(() => {
				this.filterLoading = false;	
			})
		},
		
		resetFilter() {
			this.isFiltered = false;
			this.filterData.name = null;
			this.filterData.fiscalYear = null;
			this.filter();
		},

		save() {
			this.financialFileLoading = true;
			const actionName = this.financialFile.id ? 'update' : 'create';
			this.$store.dispatch(`financialFiles/${actionName}`,{
				id: this.financialFile.id,
				company_name: this.financialFile.companyName,
				year_name: this.financialFile.yearName,
				start_date: this.financialFile.startDate,
				end_date: this.financialFile.endDate,
				default_currency_id: this.financialFile.defaultCurrencyId,
				default_language: this.financialFile.defaultLanguage
			})
			.then((data) => {
				this.loading = true;
				Promise.all([
					this.updatePermissions(this.financialFile.id ? data.id : data),
					this.filter().then(() => {
						// upload image
						if (this.financialFile.image) {
							this.$store.dispatch('financialFiles/uploadLogo', {
								id: data.id,
								file: this.financialFile.image
							})
								.then(()=>{
									EventBus.$emit(
										'notification',
										this.$t('FinancialFilesPage.the-logo-is-uploaded-successfully')
									);
			
									if(data.id == this.currentFinancialFile.id) {
										this.$store.dispatch('financialFiles/fetchFinancialFile', data.id);
									}
								})
								.finally(() => {
									this.financialFileDialog = false;
								})
						}
					})
				]).finally(() => {
					this.loading = false;
				});
			})
			.finally(() => {
				if (!this.financialFile.image) {
					this.financialFileDialog = false;
					this.financialFileLoading = false;
				}
			})
		},

		changeFinancialFile(){
			ls.setLocalFinancialFileId(this.financialFile.id)
			EventBus.$emit('financial-file-id-changed'); 
			
			this.changeFinancialFileDialog = false;
			this.$router.replace({ name: 'home' })
				.then(() => {
					this.$router.go(0);
				})
		},

		changeArchiveState(itemId, isArchive) {
			this.changeArchiveFileId = itemId;
			this.$store.dispatch('financialFiles/updateArchive', {
				id: itemId,
				isArchive
			}).then(() => {
				this.filter().finally(() => {
					this.changeArchiveFileId = null;
				})
			})
		},

		// this part of code has been moved to the users page so it will be deleted later
		// addUserPermission() {
		// 	this.userPermissions.push({ userId: null, permissionType: null, warehouseIds: null });
		// 	this.$nextTick(() => {
		// 		this.$refs.username[this.userPermissions.length - 1].focus();
		// 	});
		// },
		//

		updatePermissions(financialFileId){
			const permissions = this.userPermissions.length
				? this.userPermissions.map(c => ({
					user_id: c.userId,
					financial_file_id: financialFileId,
					permission_type: this.permissions.find(a => a.permissionType === c.permissionType).name,
					warehouse_ids: c.warehouse_ids === null ? [] : [c.warehouseIds]
				}))
				: []
			return this.$store.dispatch('financialFiles/updatePermissions', {
				id: financialFileId,
				permissions
			})
		},

		createBackup() {
			this.backupLoading = true;
			this.$store.dispatch('configs/createBackup')
				.then((file) => {
					const fileName = `${this.currentFinancialFile.name} ${new Date().toISOString().slice(0, 10)}.bak`;

					const a = document.createElement("a");
					const url = window.URL.createObjectURL(file);
					a.href = url;
					a.download = fileName;
					a.click();
					window.URL.revokeObjectURL(url);
					a.remove();
				})
				.finally(() => {
					this.backupLoading = false;
				})
		},

		getLogo(name) {
			return axios.defaults.baseURL.replace('/api/', '') + '/Content/FinancialFiles/Logos/' + name
		},

		getCurrencyById(id) {
			if (this.currentFinancialFile.id) {
				return this.configs.currencies.find(c => c.id === id);
			} else {
				return this.currencies.find(c => c.id === id);
			}
		},
	},
	created() {
		this.loading = true;
		Promise.all([
			this.filter(),
			!this.users.length ? this.$store.dispatch('users/fetchAll'): null,
			this.currentFinancialFile.id && !Object.keys(this.configs).length
				? this.$store.dispatch('configs/fetchAll')
				: null,
			!this.currentFinancialFile.id || !this.currencies.length 
				? this.$store.dispatch('currencies/fetchAll')
				: null,
			// !this.warehouses.length ? this.$store.dispatch('warehouses/fetchAll') : null
		]).finally(() => {
			this.loading = false;
		})
	}
};
</script>
<style>
</style>